<div class="text-box-container">
  <div class="question-header">
    <h6 class="question-title"
    [style.font-size]="questionnaire?.mainContentTemplate?.questionStyle?.fontSize + 'px'"
    [style.font-family]="questionnaire?.mainContentTemplate?.questionStyle?.fontFamily"
    [style.font-weight]="questionnaire?.mainContentTemplate?.questionStyle?.boldStyle"
    [style.color]="questionnaire?.mainContentTemplate?.questionStyle?.fontColor"
    >
      {{ questionNumber }}. {{ question?.question || 'Untitled Question' | titlecase }}
      @if (question?.required) {
        <span 
        [style.font-size]="'18px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.errorMessageStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontColor"
        >*</span>
      }
    </h6>
  </div>

  <div class="question-content-buttons" 
  [ngClass]="getAlignmentClass(question)">
    @for (option of options; track option.value) {
      <button
        type="button"
        class="button-option"
        [class.selected]="isSelected(option)"
        [class.disabled]="disabled"
        [attr.disabled]="disabled ? true : null"
        (click)="onButtonClick(option)">
        {{ option.label | titlecase }}
      </button>
    }
  </div>

  @if (question?.questionOptions) {
    @for (option of question?.questionOptions; track option.optionId) {
      @if (isOthersSelected(option.optionId)) {
        <div class="others-input-container">
          <input
            type="text"
            class="others-input"
            [ngModel]="getOthersText(option.optionId)"
            [disabled]="disabled"
            placeholder="Please specify"
            (ngModelChange)="onOthersTextChange(option.optionId, $event)"
            (blur)="onOthersInputBlur()"
          />
        </div>
      }
    }
  }
</div>
